import { Component, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'eup-donut',
    templateUrl: './donut.component.html',
    styleUrls: ['./donut.component.scss'],
    standalone: false,
})
export class DonutComponent {
    #sanitizer = inject(DomSanitizer);
    readonly minpercent = input.required<number>();
    readonly percent = input.required<number>();

    get deg1(): number {
        let deg1 = 90;

        // If percentage is less than 50%
        if (this.percent() < 50) {
            deg1 = (this.percent() / 100) * 360 + 90;
        }

        return deg1;
    }
    get deg2(): number {
        let deg2 = 0;

        // If percentage is less than 50%
        if (this.percent() < 50) {
            deg2 = 0;
        }

        return deg2;
    }

    public get style1() {
        return this.#sanitizer.bypassSecurityTrustStyle(
            '-webkit-transform: rotate(' +
                this.deg1 +
                'deg);transform: rotate(' +
                this.deg1 +
                'deg);background-color:' +
                this.color1 +
                ';'
        );
    }

    public get style2() {
        return this.#sanitizer.bypassSecurityTrustStyle(
            '-webkit-transform: rotate(' +
                this.deg2 +
                'deg);transform: rotate(' +
                this.deg2 +
                'deg);background-color:' +
                this.color1 +
                ';'
        );
    }

    public get color1() {
        if (this.percent() < this.minpercent()) {
            return '#e1e1e1';
        } else {
            return 'rgb(94,162,38)';
        }
    }
    public get color2() {
        if (this.percent() < this.minpercent() && this.percent() > 0) {
            return 'rgb( 192,0,0)';
        } else {
            return '#e1e1e1';
        }
    }

    public get resultcolor() {
        if (this.percent() < this.minpercent()) {
            return 'rgb( 192,0,0)';
        } else {
            return 'rgb(94,162,38)';
        }
    }
}
